export default [
  {
    type: "start",
    text: {value:"开始"},
    class: 'node-start',
    properties: {
      urgency:true,
      remind_value:['及时消息','企业微信'],
      suggestion:false,
      enclosure:true,
      is_submit:true,
      is_staging:false,
      monitor:[],
      extend:[],
      form_fields:{},
    }
  },
  {
    type: "exclusiveGateway",
    text: {value:"条件"},
    class: 'node-exclusiveGateway',
    properties: {
      monitor:[],
      extend:[],
    }
  },
  {
    type: "user",
    text: {value:"用户"},
    class: 'node-user',
    properties: {
      user_role_ids: [],
      user_role_names: [],
      fixed_user_selectable:true,
      fixed_user_list:[],
      user_number:1,
      xor:'1',
      must_pass:true,
      edit_node:false,
      handle_value:[],
      additional_value:[],
      suggestion:true,
      enclosure:true,
      is_submit:true,
      is_staging:false,
      urgency:true,
      remind_value:['及时消息','企业微信'],
      tableObject:{},
      send_copy_user_list:[],
      monitor:[],
      extend:[],
      remind_out_time:1440,//报警时间
      node_out_time:2880,//超时时间
      form_fields:{},
    }
  },
  {
    type: "setting",
    text: {value:"服务"},
    class: 'node-setting',
    properties: {
      send_copy_user_list:[],
      monitor:[],
      extend:[],
    }
  },
  {
    type: "confluence",
    text: {value:"合流"},
    class: 'node-confluence',
    properties: {
      monitor:[],
      extend:[],
    }
  },
  {
    type: "distributary",
    text: {value:"分流"},
    class: 'node-distributary',
    properties: {
      monitor:[],
      extend:[],
    }
  },
  {
    type: "end",
    text: {value:"结束"},
    class: 'node-end',
    properties: {
      send_copy_user_list:[],
      monitor:[],
      extend:[],
    }
  },
  {
    type: "polyline",
    text: "",
    properties: {
      condition:[],
      send_copy_user_list:[],
      monitor:[],
      extend:[],
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/lib/DefaultConfig.js